import { render, staticRenderFns } from "./TableHelmet.vue?vue&type=template&id=2beb9bb4"
import script from "./TableHelmet.vue?vue&type=script&lang=js"
export * from "./TableHelmet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports